import { render, staticRenderFns } from "./BorrowListTable.vue?vue&type=template&id=05c7bbdc&scoped=true&"
import script from "./BorrowListTable.vue?vue&type=script&lang=js&"
export * from "./BorrowListTable.vue?vue&type=script&lang=js&"
import style0 from "./BorrowListTable.vue?vue&type=style&index=0&id=05c7bbdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c7bbdc",
  null
  
)

export default component.exports